import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const gsapAnimations = () => {

    gsap.registerPlugin(ScrollTrigger);

    const pinnedBlock = document.querySelector(".pinned-images--block");
    const pinnedInner = document.querySelector(".pinned-images--wrapper");
    const pinnedImages = document.querySelectorAll(".pinned-image");

    if (pinnedBlock && pinnedInner) {

        // Get the height of the inner content
        const innerHeight = pinnedInner.offsetHeight;
        const blockHeight = pinnedBlock.offsetHeight;

        // Calculate the combined height of all pinned images
        let totalImagesHeight = 0;
        pinnedImages.forEach(image => {
            totalImagesHeight += image.offsetHeight;
        });

        // Calculate the end position based on combined image heights
        const endPosition = totalImagesHeight - blockHeight;

        // Pin the block
        gsap.to(".pinned-images--block", {
            scrollTrigger: {
                trigger: ".pinned-images--block",
                pin: true,
                start: "top top",
                end: `+=${endPosition}px`,
                scrub: true,
            }
        });

        // Animate the inner content Y translation
        gsap.to(".pinned-images--wrapper", {
            y: -endPosition,
            scrollTrigger: {
                trigger: ".pinned-images--block",
                start: "top top",
                end: `+=${endPosition}px`,
                scrub: true
            }
        });
    }


    const numbers = document.querySelectorAll(".number");

    if (numbers.length > 0) {

        // Find integers, alpha characters, and special characters in numbers and wrap them in spans
        numbers.forEach(numberElement => {
            const text = numberElement.textContent;
            // Replace integers, alpha, and special characters with respective spans
            const newHTML = text.replace(/(\d+)|([a-zA-Z]+)|([^a-zA-Z\d]+)/g, (match, integer, alpha, special) => {
                if (integer) {
                    return `<span class="number-integer" data-number="${integer}">${integer}</span>`;
                } else if (alpha) {
                    return `<span class="number-alpha">${alpha}</span>`;
                } else if (special) {
                    return `<span class="number-special">${special}</span>`;
                }
                return match;
            });
            numberElement.innerHTML = newHTML;
        });

		// Animate only when each `.number` element gains the 'over' class
		numbers.forEach(numberEl => {
			let hasPlayed = false;

			const playIfOver = () => {
				if (!hasPlayed && numberEl.classList.contains("over")) {
					hasPlayed = true;
					const scopedIntegers = numberEl.querySelectorAll(".number-integer");
					if (scopedIntegers.length > 0) {
						gsap.from(scopedIntegers, {
							textContent: 0,
							duration: 3,
							ease: "power1.in",
							snap: { textContent: 1 }
							// onUpdate: textContent.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
						});
					}
				}
			};

			// In case the class is already present on load
			playIfOver();

			// Observe class changes to detect when 'over' is added
			const observer = new MutationObserver(mutations => {
				for (const mutation of mutations) {
					if (mutation.type === "attributes" && mutation.attributeName === "class") {
						playIfOver();
					}
				}
			});

			observer.observe(numberEl, { attributes: true });
		});
    }

}